import { Component, Input, OnInit } from '@angular/core';
import { GymFinderService } from '../../../service/gymfinder.service';

@Component({
  selector: 'gymfinder-changelog-studio-type',
  templateUrl: './changelog-studio-type.component.html',
  standalone: false,
})
export class ChangelogStudioTypeComponent implements OnInit {
  @Input()
  studioType: string;

  studioTypeValue: string;

  constructor(private gymFinderService: GymFinderService) {}

  ngOnInit() {
    this.getStudioType();
  }

  getStudioType() {
    this.gymFinderService.getStudioTypes().subscribe({
      next: studioTypes => {
        this.studioTypeValue =
          studioTypes.find(st => st.name === this.studioType)?.value ||
          this.studioType;
      },
      error: () => {
        this.studioTypeValue = this.studioType;
      },
    });
  }
}
